import { RiArrowGoBackFill } from "react-icons/ri";
import { Link } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import { E_immatriculation } from "../../../../constants/constant";
import Label from "../../../../components/title/label";
import Input from "../../../../components/input/Input";
import { Navbar } from "../../../../components/navbar/Navbar";
import BackButton from "../../../../components/button/BackButton";


  
function InterlocuteurContribuable() {

    const [interlocuteur, setInterlocuteur] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [successMessage] = useState(null);
  
    const selectedData = localStorage.getItem("selectedDataPriseEnCharge");
    const contribuableData = selectedData ? JSON.parse(selectedData) : null;
  
    useEffect(() => {
      const fetchInterlocuteur = async () => {
        if (!contribuableData?.id) return;
        
        setIsLoading(true);
        setError(null);
        
        try {
          const response = await axios.get(
            `${E_immatriculation}/interlocuteur/contribuable/${contribuableData.id}`
          );
          setInterlocuteur(response.data[0] || null);
        } catch (err) {
          setError("Erreur lors du chargement des données");
          console.error(err);
        } finally {
          setIsLoading(false);
        }
      };
  
      fetchInterlocuteur();
    }, [contribuableData?.id]);
  
    const handleInputChange = (field, value) => {
      if (!interlocuteur) return;
      
      setInterlocuteur({
        ...interlocuteur,
        [field]: value,
      });
    };
  
   
    
  
    if (isLoading) return <div className="text-center p-4">Chargement...</div>;
    if (!interlocuteur) return <div className="text-center p-4">Aucune donnée trouvée</div>;
  
  // Navbar content
  const contentNavbar = (
    <nav className="flex items-center justify-between">
     <div className="text-white">
       Interlocuteur
     </div>
      <BackButton to="/SituationGeographiqueIm"></BackButton>
    </nav>
  );
    return (

         <div className="w-full bg-[#212122] h-screen">
           <Navbar content={contentNavbar} />
           <main className=""><div>
          
  
          <div className="flex justify-center  p-4">
            <div className="flex flex-col w-full max-w-2xl">
              {error && (
                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                  {error}
                </div>
              )}
              {successMessage && (
                <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
                  {successMessage}
                </div>
              )}
  
              <div className="space-y-6">
                <div className="flex justify-between">
                  <Label text="Nom *" />
                  <Input
                    type="text"
                    value={interlocuteur.nom_interlocuteur}
                    onChange={(e) => handleInputChange("nom_interlocuteur", e.target.value)}
                  />
                </div>
  
                <div className="flex justify-between">
                  <Label text="Titre" />
                  <Input
                    type="text"
                    value={interlocuteur.titre_interlocuteur}
                    onChange={(e) => handleInputChange("titre_interlocuteur", e.target.value)}
                  />
                </div>
  
                <div className="flex justify-between">
                  <Label text="Adresse" />
                  <Input
                    type="text"
                    value={interlocuteur.adresse_interlocuteur}
                    onChange={(e) => handleInputChange("adresse_interlocuteur", e.target.value)}
                  />
                </div>
  
                <div className="flex justify-between">
                  <Label text="Téléphone *" />
                  <Input
                    type="tel"
                    value={interlocuteur.telephone_interlocuteur}
                    onChange={(e) => handleInputChange("telephone_interlocuteur", e.target.value)}
                  />
                </div>
  
                <div className="flex justify-between">
                  <Label text="E-mail *" />
                  <Input
                    type="email"
                    value={interlocuteur.email_interlocuteur}
                    onChange={(e) => handleInputChange("email_interlocuteur", e.target.value)}
                  />
                </div>
  
                <div className="flex justify-center gap-4">
                  
                  <Link
                    to="/SituationGeographiqueIm"
                    className="border-[2px] p-2 text-white border-white rounded hover:bg-black/70 hover:text-white flex flex-row items-center"
                  >
                    <RiArrowGoBackFill className="text-2xl text-white mr-2" />
                    Fermer
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div></main>
         </div> 
    );
  }

export default InterlocuteurContribuable